import { http } from '../http';

export const getContactFunds = async (contactId) => {
  const url = `/contacts/${contactId}/funds`;
  const response = await http.get(url, { baseURL: process.env.BFFV2_BASE_URL });
  if (!response?.data) {
    throw new Error("Can't get contact funds");
  }
  return response?.data || [];
};

export default {
  getContactFunds,
};
